@use "variables" as *;

.checkbox {
  > label {
    &:hover {
      background-image: none !important;
    }
  }
  white-space: normal;
}

.container {
  display: flex;
  align-items: center;
}

.suffixElement {
  padding-left: $spacing-2;
  margin-left: auto;
}
